/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  LiquidityProviderSandbox,
  LiquidityProviderSandboxInterface,
} from "../LiquidityProviderSandbox";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "owner_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "contract ILiquidityProvider",
        name: "provider",
        type: "address",
      },
      {
        internalType: "contract IERC20TokenV06",
        name: "outputToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "minBuyAmount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "auxiliaryData",
        type: "bytes",
      },
    ],
    name: "executeSellEthForToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ILiquidityProvider",
        name: "provider",
        type: "address",
      },
      {
        internalType: "contract IERC20TokenV06",
        name: "inputToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "minBuyAmount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "auxiliaryData",
        type: "bytes",
      },
    ],
    name: "executeSellTokenForEth",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ILiquidityProvider",
        name: "provider",
        type: "address",
      },
      {
        internalType: "contract IERC20TokenV06",
        name: "inputToken",
        type: "address",
      },
      {
        internalType: "contract IERC20TokenV06",
        name: "outputToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "minBuyAmount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "auxiliaryData",
        type: "bytes",
      },
    ],
    name: "executeSellTokenForToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

export class LiquidityProviderSandbox__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    owner_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<LiquidityProviderSandbox> {
    return super.deploy(
      owner_,
      overrides || {}
    ) as Promise<LiquidityProviderSandbox>;
  }
  getDeployTransaction(
    owner_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(owner_, overrides || {});
  }
  attach(address: string): LiquidityProviderSandbox {
    return super.attach(address) as LiquidityProviderSandbox;
  }
  connect(signer: Signer): LiquidityProviderSandbox__factory {
    return super.connect(signer) as LiquidityProviderSandbox__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): LiquidityProviderSandboxInterface {
    return new utils.Interface(_abi) as LiquidityProviderSandboxInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): LiquidityProviderSandbox {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as LiquidityProviderSandbox;
  }
}
